import React from 'react';
import AdvisoryBoardCarousel from '../../component/common/advisory';
import MediaCarousel from '../../component/common/media';
import CTA from '../../component/common/CTA';
import Hero from '../../component/home/hero';
import WhatWeDo from '../../component/home/whatWeDo';
import HowWeDoIt from '../../component/home/howWeDoIt';
import { FaArrowRight } from "react-icons/fa6";
import { Helmet } from 'react-helmet-async';


const boardMembers = [
    {
        img: "/img/advisory/ashish.png",
        name: "Ashish Mittal",
        position: "Founder & Chief Mentor",
        link: "https://www.linkedin.com/in/mittalashish",
    },
    {
        img: "/img/advisory/vivek.jpg",
        name: "Vivek Srivastava",
        position: "HealthTech Advisor",
        link: "https://www.linkedin.com/in/vivek-srivastava-/",
    },
    {
        img: "/img/advisory/prashant.jpg",
        name: "Prashant Lohia",
        position: "RetailTech Advisor",
        link: "https://www.linkedin.com/in/ginesys/",
    },
    {
        img: "/img/advisory/gagan.jpg",
        name: "Gagan Jain",
        position: "SaaSTech Advisor",
        link: "https://www.linkedin.com/in/gaganmsjain/",
    },
    {
        img: "/img/advisory/vikas.jpg",
        name: "Vikas Chowdhary",
        position: "Fintech Advisor",
        link: "https://www.linkedin.com/in/vikaschaudhary-6equj5/",
    },
    {
        img: "https://picsum.photos/600/600",
        name: "Dr. V Gopal",
        position: "Edtech Advisor",
        link: "https://www.linkedin.com/in/dr-v-gopal-5a6082a",
    },
];

const mediaData = [
    {
        title: "Student housing Startup Your-space raises Angel Funding",
        date: "January 2025",
        link: "https://www.vccircle.com/exclusive-student-housing-startup-your-space-raises-angel-funding",
    },
    {
        title: "TurningIdeas Venture to help startups with early investments",
        date: "February 2025",
        link: "https://economictimes.indiatimes.com/small-biz/money/turningideas-venture-to-help-startups-with-early-investments/articleshow/52863561.cms",
    },
    {
        title: "42 per cent of Indian Startups Plan to Go Global",
        date: "January 2025",
        link: "https://www.business-standard.com/content/press-releases-ani/42-per-cent-of-indian-startups-plan-to-go-global-in-2022-turningideas-survey-121121601096_1.html",
    },
    {
        title: "Student housing Startup Your-space raises Angel Funding",
        date: "January 2025",
        link: "https://www.vccircle.com/exclusive-student-housing-startup-your-space-raises-angel-funding",
    },
];

const HomePage = () => {
    return (
        <div className="">

            <Helmet>
                <title>TurningIdeas – Startup Studio for Accelerating Growth & Global Expansion</title>
                <meta name="description" content="TurningIdeas is a startup studio helping Indian startups accelerate growth and global startups scale in India. Get expert support in strategy, sales, and product development." />
                <meta name="keywords" content="Startup Studio, Indian Startups, Global Startups, Scale in India, Growth Acceleration, Market Entry, Startup Funding, Product Development, Sales Execution, Startup Growth, Go-To-Market, Enterprise Partnerships, Innovation Hub, Startup Mentorship" />
            </Helmet>




            {/* Hero Section */}
            <section className="bggg bg-cover bg-center bg-no-repeat text-white py-12 md:pb-44 pb-32">

                <Hero />


            </section>

            {/* Co-Build Section */}
            <section className="pb-12 md:py-24 bg-gray-100 text-left">
                <div className="container max-w-7xl mx-auto px-6 md:px-12">
                    <div className="flex flex-col md:flex-row items-center justify-between">
                        <div className="md:w-1/2 md:mb-0">
                            <h2 className="text-4xl md:text-5xl lg:text-[48px] leading-tight mb-4">More Than Just Funding,</h2>
                            <h3 className="text-4xl md:text-5xl lg:text-[48px] leading-tight font-semibold mb-6">We Co-Build Startups</h3>
                            <p className="mt-3 text-lg md:text-xl lg:text-[20px] leading-relaxed text-gray-700">
                                Turning Ideas is not just an investor -
                                we are strategic partners who actively co-create, validate, and scale high-growth startups.
                            </p>

                            <ul className="mt-8 space-y-2 text-lg md:text-xl lg:text-[20px] leading-relaxed text-gray-700">
                                <li className="flex items-start">
                                    <div className="h-6 w-6 rounded-full bg-yellow-500 flex items-center justify-center text-white mr-3">
                                        <FaArrowRight className="text-xs" />
                                    </div>
                                    <span>Startup Co-Creation</span>
                                </li>
                                <li className="flex items-start">
                                    <div className="h-6 w-6 rounded-full bg-yellow-500 flex items-center justify-center text-white mr-3">
                                        <FaArrowRight className="text-xs" />
                                    </div>
                                    <span>Sales & GTM Strategy</span>
                                </li>
                                <li className="flex items-start">
                                    <div className="h-6 w-6 rounded-full bg-yellow-500 flex items-center justify-center text-white mr-3">
                                        <FaArrowRight className="text-xs" />
                                    </div>
                                    <span>Product & Tech Developments</span>
                                </li>
                                <li className="flex items-start">
                                    <div className="h-6 w-6 rounded-full bg-yellow-500 flex items-center justify-center text-white mr-3">
                                        <FaArrowRight className="text-xs" />
                                    </div>
                                    <span>Corporate Innovation</span>
                                </li>
                            </ul>

                            <a href="/about">
                                <button className="mt-6 bg-blue-600 text-white font-medium text-sm py-2 px-6 rounded-full hover:bg-blue-700 transition-colors duration-300">
                                    Know More
                                </button>
                            </a>

                        </div>
                        <div className="md:w-1/2 hidden md:flex justify-center">
                            <img
                                src="img/five-light-bulbs.png"
                                alt="Light bulb idea"
                                className="w-full max-w-md h-auto"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <div className="hidden md:flex justify-center ">
                <div className="relative" >
                    <div
                        className="w-[32rem] h-[16rem] pb-12 rounded-t-full flex items-end justify-center"
                        style={{ background: "#181F85" }}
                    >
                        <h2 className="text-3xl md:text-4xl lg:text-[48px] leading-tight font-semibold text-white tracking-tight">What We Do</h2>
                    </div>
                    {/* Blue bar extending full width */}
                    <div
                        className="absolute bottom-0 w-screen left-1/2 transform -translate-x-1/2 h-8"
                    // style={{ background: "linear-gradient(45deg, #009CB8, #181F85)" }}
                    ></div>
                </div>
            </div>

            <section className="md:py-12 py-6" style={{ background: "linear-gradient(180deg, rgba(24,31,133,1) 0%, rgba(24,31,133,1) 20%, rgba(0,212,255,1) 100%, rgba(0,212,255,1) 100%)" }}>
                <div className="container mx-auto px-6 md:px-12">
                    <WhatWeDo />
                </div>
            </section>

            <section className="md:pt-12 bg-gray-50">
                <div className="container mx-auto px-6 md:px-12">
                    <HowWeDoIt />
                </div>
            </section>

            <section className="md:pb-12 bg-gray-50">
                <div className="container mx-auto px-6 md:px-12">
                    <AdvisoryBoardCarousel members={boardMembers} />
                </div>
            </section>

            <section className="md:py-12 bg-black">
                <div className="container mx-auto px-6 md:px-12">
                    <MediaCarousel mediaItems={mediaData} />
                </div>
            </section>

            <CTA
                heading="Let’s Build Together"
                subheading="Join the TurningIdeas Ecosystem"
                paragraph="Whether you're a startup, investor, or enterprise, we help you scale, innovate, and succeed."
                buttonText="Contact Us Today!"
            />

        </div>
    );
};

export default HomePage;
